import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'

interface SummaryMarqueeProps {
  children: React.ReactNode
}

const StyledMarqueeWrapper = styled.div`
  display: flex;
  overflow: hidden;
  width: 100%;
`

const StyledMarqueeItemsWrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing32 },
    },
  }) => css`
    animation-duration: 32s;
    animation-iteration-count: infinite;
    animation-name: marquee-content;
    animation-timing-function: linear;

    display: flex;
    gap: ${spacing32};
    padding-left: ${spacing32};

    @keyframes marquee-content {
      from {
        transform: translateX(0%);
      }
      to {
        transform: translateX(-100%);
      }
    }
  `}
`

const SummaryMarquee: FunctionComponent<SummaryMarqueeProps> = ({
  children,
}) => {
  return (
    <StyledMarqueeWrapper>
      {Array.from(Array(2), (_, index) => (
        <StyledMarqueeItemsWrapper key={`${index}-marquee-item`}>
          {children}
        </StyledMarqueeItemsWrapper>
      ))}
    </StyledMarqueeWrapper>
  )
}

export default SummaryMarquee
